module.exports = __webpack_public_path__ + "img/sys.3ab179ce.png";